import {Overlay} from "ol";

export class ContextMenuFeature {
    overlay = null;
    position = undefined;
    pixel = null;

    constructor(epMap) {
        this.epMap = epMap;

        this.setupOverlay();
        this.setupEvents();
    }

    setupEvents() {
        let that = this;

        this.epMap.map.on('contextmenu', function (evt) {
            evt.preventDefault();
            that.position = evt.coordinate;
            that.pixel = evt.pixel;

            if(that.overlay && that.overlay.getElement()) {
                that.overlay.setPosition(that.position);

                const element = that.overlay.getElement();
                $(element).find('ul')
                    .empty()
                    .append(that.buildMenuItems());

                if($(element).find('[data-app-context_menu]').length === 0) {
                    return;
                }

                let dropdown = bootstrap.Dropdown.getInstance(element);
                if (dropdown) {
                    dropdown.hide();
                    dropdown.dispose();
                }
                dropdown = new bootstrap.Dropdown(element, {
                    reference: 'parent',
                    autoClose: 'outside'
                });
                dropdown.show();
            }
        })

        $('body').on('click', '[data-app-context_menu]', function() {
            let name = $(this).data('app-context_menu');
            let item = that.epMap.contextMenu.getItem(name);

            if(item) {
                if(typeof item.onClick == 'function') {
                    let closeDropdown = item.onClick(
                        that,
                        that.epMap,
                    )

                    if(closeDropdown) {
                        const element = that.overlay.getElement();

                        let dropdown = bootstrap.Dropdown.getInstance(element);
                        if (dropdown) {
                            dropdown.hide();
                            dropdown.dispose();
                        }
                    }
                }
            }
        })
    }

    buildMenuElement() {
        return $(`
            <div class="dropdown">
                <ul class="dropdown-menu shadow">
                    
                </ul>
            </div>
        `);
    }

    buildMenuItems() {
        let items = this.epMap.contextMenu.sortItems(
            this.epMap.contextMenu.items
                .filter(item => {
                    if(typeof item.shouldRender == 'function') {
                        if(item.shouldRender(this, this.epMap) === false) {
                            return false;
                        }
                    }

                    return true;
                })
        )

        return $(`
            ${items.map((item, index) => {
                if(item.name === 'divider') {
                    return `<li class="dropdown-divider"></li>`
                }
                
                let divider = '';
                
                if(typeof item.group != 'undefined') {
                    if(typeof items[index-1] != 'undefined' && items[index-1].group !== item.group) {
                        divider = '<li class="dropdown-divider"></li>';
                    }
                }
                
                let title = item.title;
                if(typeof title == 'function') {
                    title = title(this);
                }
    
                return `
                    ${divider}
                    <li><button data-app-context_menu="${item.name}" class="dropdown-item" type="button">${title}</button></li>
                `
            }).join('')}
        `)
    }

    setupOverlay() {
        const element = this.buildMenuElement();
        function listener(event) {
            if (!element[0].contains(event.target)) {
                const dropdown = bootstrap.Dropdown.getInstance(element[0]);
                if (dropdown) {
                    dropdown.hide();
                }
            }
        }

        if(this.overlay) {
            this.epMap.map.removeOverlay(this.overlay);
            document.removeEventListener('click', listener);
        }

        document.addEventListener('click', listener);

        this.overlay = new Overlay({
            element: element[0],
        })

        this.epMap.map.addOverlay(this.overlay);
    }

    getFeaturesAtClickedPosition(tolerance = 0) {
        return this.epMap.map.getFeaturesAtPixel(this.pixel, {hitTolerance: tolerance});
    }
}